export default {"src":"https://webcdn.trailways.ca/_next/static/media/sign-out.ecb275c4.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};